import _ from "lodash";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { productTypes, categories } from "data/actions";

import MenuLink from "components/Navigation/MenuLink";

import ActionDelete from "material-ui/svg-icons/action/delete";

import { Page, PageBlock, RightDrawer } from "components/Page";

import Subheader from "material-ui/Subheader";
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow
} from "material-ui/Table";
import ClickableRowColumn from "components/Grid/ClickableRowColumn";
import ClickableRow from "components/Grid/ClickableRow";

import RaisedButton from "material-ui/RaisedButton";
import ContentAdd from "material-ui/svg-icons/content/add";
import * as os from "osutil";

class ProducttypePage extends Component {
  state = { selected: [] };

  static contextTypes = {
    router: PropTypes.object
  };

  componentWillMount() {
    this.props.actions.fetchProducttypes();
    this.props.actions.fetchCategories();
  }

  handleDeleteClick = id => {
    this.props.actions.deleteProducttype(id);
  };

  handleEditClick = id => {
    this.context.router.history.push("/admin/producttype/" + id);
  };

  addProducttype = e => {
    this.props.actions.createProducttype(
      { name: "New producttype" },
      this.handleEditClick
    );
  };

  deleteProducttypes = e => {
    _.each(this.state.selected, p =>
      this.props.actions.deleteProducttype(p.key)
    );
  };

  onRowSelection = rows => {
    var selected = rows.map(i => this.props.producttypes[i]).filter(r => !!r);
    this.setState({ selected: selected });
  };

  renderProducttypes() {
    return _.map(this.props.producttypes, producttype => {
      if (this.props.categories[producttype.categoryid]) {
        var channel = this.props.categories[producttype.categoryid];
      }
      console.log(this.props.categories);
      return (
        <ClickableRow
          key={producttype.key}
          onMyRowClick={() => this.handleEditClick(producttype.key)}
        >
          <ClickableRowColumn>{producttype.name}</ClickableRowColumn>
          <ClickableRowColumn>{channel ? channel.name : ""}</ClickableRowColumn>
          <ClickableRowColumn>{producttype.description}</ClickableRowColumn>
        </ClickableRow>
      );
    });
  }
  render() {
    return [
      <RightDrawer key="right">
        <PageBlock label="Produkttyper">
          {this.state.selected.length ? (
            <RaisedButton
              mini
              secondary
              onClick={this.deleteProducttypes}
            >
              <ActionDelete />
            </RaisedButton>
          ) : (
            ""
          )}
          <RaisedButton onClick={this.addProducttype}>
            Skapa ny
          </RaisedButton>
        </PageBlock>
      </RightDrawer>,
      <Page key="page" ready={!this.props.pending}>
        <Table multiSelectable onRowSelection={this.onRowSelection}>
          <TableHeader displaySelectAll={false}>
            <TableRow>
              <TableHeaderColumn>Namn</TableHeaderColumn>
              <TableHeaderColumn>Kanal</TableHeaderColumn>
              <TableHeaderColumn>Beskrivning</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody deselectOnClickaway={false}>
            {this.renderProducttypes()}
          </TableBody>
        </Table>
      </Page>
    ];
  }
}

function mapStateToProps(state) {
  return {
    producttypes: os.collection_to_array(state.producttypes.list.data),
    categories: state.categories.list.data,
    pending: state.producttypes.list.pending
  };
}

const mapDispatch = dispatch => {
  console.log(productTypes);
  return {
    actions: bindActionCreators({ ...categories, ...productTypes }, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatch)(ProducttypePage);



// WEBPACK FOOTER //
// ./src/pages/admin/producttypes/ProductTypeListPage.jsx